import { useQuery } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import {
  WorkspaceQuizResponse,
  getWorkspaceQuiz,
} from '../../../api/workspaces/quizzes/getWorkspaceQuiz';

interface UseGetWorkspaceQuizParams<T = WorkspaceQuizResponse> {
  workspaceId: string;
  workspaceQuizId: string;
  staleTime?: number;
  select?: (workspaceQuiz: WorkspaceQuizResponse) => T;
}

export function useGetWorkspaceQuiz<T = WorkspaceQuizResponse>({
  workspaceId,
  workspaceQuizId,
  staleTime,
  select,
}: UseGetWorkspaceQuizParams<T>) {
  return useQuery({
    queryFn: () => getWorkspaceQuiz({ workspaceQuizId, workspaceId }),
    queryKey: workspaceKeys.byWorkspaceQuizId({ workspaceQuizId, workspaceId }),
    staleTime: staleTime,
    select,
  });
}
